import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-array/src/zip.js
// module id = ../../../../d3-array/src/zip.js
// module chunks = 4